import _objectSpread from "@babel/runtime/helpers/objectSpread2";
export default function convertAvatarGroup(component) {
  var properties = component.properties;
  var props = properties;
  return {
    brick: "eo-avatar-group",
    properties: _objectSpread(_objectSpread({}, props), {}, {
      themeVariant: "elevo"
    })
  };
}
//# sourceMappingURL=convertAvatarGroup.js.map